/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Media_Loaded_MessageInputs */

const en_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media loaded successfully`)
};

const fr_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media charge avec succes`)
};

const de_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien erfolgreich geladen`)
};

const it_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto caricato correttamente`)
};

const ru_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайл успешно загружен.`)
};

const es_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios cargados exitosamente`)
};

const zh_cn2_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体文件加载成功`)
};

const ja_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアが正常に読み込まれました`)
};

const hi_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया सफलतापूर्वक लोड हो गया`)
};

const pt_pt2_iframe_remote_media_loaded_message = /** @type {(inputs: Iframe_Remote_Media_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia carregada com sucesso`)
};

/**
* | output |
* | --- |
* | "Media loaded successfully" |
*
* @param {Iframe_Remote_Media_Loaded_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_media_loaded_message = /** @type {((inputs?: Iframe_Remote_Media_Loaded_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Media_Loaded_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_media_loaded_message(inputs)
	if (locale === "de") return de_iframe_remote_media_loaded_message(inputs)
	if (locale === "it") return it_iframe_remote_media_loaded_message(inputs)
	if (locale === "ru") return ru_iframe_remote_media_loaded_message(inputs)
	if (locale === "es") return es_iframe_remote_media_loaded_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_media_loaded_message(inputs)
	if (locale === "ja") return ja_iframe_remote_media_loaded_message(inputs)
	if (locale === "hi") return hi_iframe_remote_media_loaded_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_media_loaded_message(inputs)
	return en_iframe_remote_media_loaded_message(inputs)
});